module.exports = __webpack_public_path__ + "static/img/bangonglou zhaopian.0975a72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bangonglou zhaopian.png
// module id = mw2G
// module chunks = 1